import { api } from './api';
import { Request } from '../types/api.types';

export const requestsApi = {

    create: (data: Partial<Request>): Promise<Request> =>
        api.post('/site/requests', data).then(res => res.data),

    getAll: (): Promise<Request[]> =>
        api.get('/admin/requests').then(res => res.data),

    getByStatus: (status: string): Promise<Request[]> =>
        api.get(`/admin/requests/status/${status}`).then(res => res.data),

    updateStatus: (id: number, status: string): Promise<Request> =>
        api.put(`/admin/requests/${id}/status?status=${status}`).then(res => res.data),

    delete: (id: number): Promise<void> =>
        api.delete(`/admin/requests/${id}`),
};